module.exports = "https://cdn-b2c.dom.ru/b2c-domru/2.357.4/frontend/_next/static/images/advantages_1_L2-9379d716d7e83804904dc759603b112a.png";